module.exports = __webpack_public_path__ + "media/RMR Quick Tip Check Balance 1.d346b374.mp4";